<script lang="ts">
  let clazz = '';
  export { clazz as class };

  // N.B. This approach is not reactive on slot's content, so over and under will get out of sync.
  // To fix, you need to wrap this with {#key} on the content.

  // https://stackoverflow.com/a/58182814/8107589
  let slot: HTMLElement | undefined;
</script>

<div class="relative {clazz}">
  <div class="over" bind:this={slot}><slot /></div>
  <div class="under">{@html slot?.innerHTML}</div>
</div>

<style lang="scss">
  :root {
    --outline-color: black;
    --outline-stroke: 0.5rem;
  }

  .under {
    color: black;
    -webkit-text-stroke: var(--outline-stroke) var(--outline-color);
  }

  .over {
    position: absolute;
    z-index: 1;
  }
</style>
